<template>
    <div class="grid">
        <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
        <Toast />
        <div class="col-12 sticky">
            <div id="custom_card" class="card">
                <div class="grid justify-content-between">
                    <div class="col-12 md:col-6">
                        <div
                            class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3">
                            <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ $t("attendance") }} ( {{ product.worker_name }} - {{ product.mobile_no }})
                            </p>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div
                            class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3">
                            <Button @click="back" class="p-button-danger" :label="$t('goback')"
                                icon="pi pi-angle-double-left" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card" id="custom_card">
                <div class="grid p-fluid">
                    <!-- <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                    disabled
                  >
                  </InputText>
                  <label>{{ $t("search") }}</label>
                </span>
              </div>
            </div>
          </div> -->
                    <div class="col-12 md:col-12">
                        <FullCalendar :options="calendarOptions" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
//https://fullcalendar.io/
//npm install @fullcalendar/core @fullcalendar/daygrid @fullcalendar/vue3
export default {
    name: 'AttendanceCalendar',
    components: {
        FullCalendar
    },
    data() {
        return {
            isLoadingModel: false,
            fullPage: false,
            product: '',
            worker_name: '',
            calendarOptions: {
                dayHeaderFormat: { weekday: 'long' },
                titleFormat: { year: 'numeric', month: 'long' },
                locale: 'en',
                events: [],
                height: 'auto',
                contentHeight: 'auto',
                plugins: [dayGridPlugin],
                initialView: 'dayGridMonth',
                headerToolbar: {
                    left: 'prevYear prev,next nextYear today',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,dayGridDay'
                },
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: 'short',
                    hour12: true
                },
            },
        }
    },
    watch: {
        currentLocale() {
            this.calendarOptions.locale = this.currentLocale;
            this.get_list();
        }
    },
    async mounted() {
        if (localStorage.getItem("product")) {
            this.product = await JSON.parse(localStorage.getItem("product"));
            localStorage.setItem("product", "");
            this.search_filter = this.product.mobile_no;
            this.get_list();
        } else {
            this.$toast.add({
                severity: "error",
                summary: "Error!!!",
                detail: "Details Not Found",
                life: 3000,
            });
            return false;
        }
    },
    methods: {
        dateFormatYMD(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == "NaN-NaN-NaN") {
                    return postdate;
                } else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == "aN") {
                        return postdate;
                    } else {
                        return year + "-" + month + "-" + date;
                    }
                }
            } else {
                return "";
            }
        },
        back() {
            this.$router.push({
                name: "WorkerProfile",
            });
        },
        get_list() {
            var data = {
                "client_id": localStorage.getItem('client_id'),
                "mobile_no": this.product.mobile_no,
                "lang": this.$i18n.locale,
                "count": false
            };
            this.isLoadingModel = true;
            var promise = apis.GetAttendance(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                var rows = response.data.data;
                this.calendarOptions.events = rows.map(item => ({
                    title: this.$t("present"),
                    start: item.attendance_date,
                    allDay: false,
                    backgroundColor: '#22c55e',
                    borderColor: '#16a34a',
                    textColor: '#ffffff'
                }))
            });
        },
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
    },
}
</script>
<style scoped>
@import "~@fullcalendar/common/main.css";
@import "~@fullcalendar/daygrid/main.css";
</style>
